import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import {
  GraphElementType,
  GraphMode,
  TraceCytoElement,
  TraceLinkProps,
} from "@/types";
import { deltaStore, selectionStore, useTheme } from "@/hooks";
import { CyElement } from "@/components/graph/base";


/**
 * Displays trace link edges between artifacts.
 */
const __default__ = {
  name: "TraceLink",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifactsInView: {},
    trace: {}
  },
  setup(__props: any) {

const props = __props;

const { darkMode } = useTheme();

const faded = computed(
  () =>
    !props.artifactsInView.includes(props.trace.targetId) ||
    !props.artifactsInView.includes(props.trace.sourceId)
);

const definition = computed<TraceCytoElement>(() => ({
  data: {
    type: GraphElementType.edge,
    graph: "tree" as GraphMode,
    id: props.trace.traceLinkId,

    // Reversed to show arrow toward parent.
    source: props.trace.targetId,
    target: props.trace.sourceId,

    deltaType: deltaStore.inDeltaView
      ? deltaStore.getTraceDeltaType(props.trace.traceLinkId)
      : undefined,
    faded: faded.value,
    traceType: props.trace.traceType,
    approvalStatus: props.trace.approvalStatus,
    score: props.trace.score,
    dark: darkMode.value,
  },
  classes: props.trace.sourceId === props.trace.targetId ? "loop" : "",
}));

/**
 * Selects this trace link.
 */
function handleSelect(): void {
  selectionStore.selectTraceLink(props.trace);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CyElement), {
    definition: definition.value,
    onClick: handleSelect
  }, null, 8, ["definition"]))
}
}

})